"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CwDropdownMultiItem = _interopRequireDefault(require("./CwDropdownMultiItem"));

var _CwDropdownMulti = _interopRequireDefault(require("./CwDropdownMulti.scss"));

var _domScrollIntoView = _interopRequireDefault(require("dom-scroll-into-view"));
/**
 * Based on react-autocomplete:
 * https://github.com/reactjs/react-autocomplete
 */


var CwDropdownMulti =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(CwDropdownMulti, _React$Component);

  function CwDropdownMulti(props) {
    var _this;

    (0, _classCallCheck2.default)(this, CwDropdownMulti);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(CwDropdownMulti).call(this, props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleItemMouseEnter", function (index, enterPosition) {
      // Don't fire onMouseEnter if mouse didn't actually move (i.e. the dropdown was scrolled by arrow keys)
      if (_this.props.onMouseEnter && (_this._mousePosition.x !== enterPosition.x || _this._mousePosition.y !== enterPosition.y)) {
        _this.props.onMouseEnter(index);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleItemMouseMove", function (position) {
      _this._mousePosition = position;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleItemClick", function (item) {
      if (_this.props.onClick) {
        _this.props.onClick(item);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleItemMouseDown", function (blur) {
      if (_this.props.onMouseDown) {
        _this.props.onMouseDown(blur);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "isMousedOver", function () {
      return _this._mousedOver;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleDropdownEnter", function () {
      _this._mousedOver = true;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleDropdownLeave", function () {
      _this._mousedOver = false;
    });
    _this._mousePosition = {
      x: 0,
      y: 0
    };
    _this._mousedOver = false;
    return _this;
  }

  (0, _createClass2.default)(CwDropdownMulti, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.scrollItemIntoView();
    }
  }, {
    key: "scrollItemIntoView",
    value: function scrollItemIntoView() {
      var highlightedItem = this.refs["item-".concat(this.props.highlightedIndex)];

      if (highlightedItem) {
        var itemNode = highlightedItem.div;
        var menuNode = this.refs.menu;
        (0, _domScrollIntoView.default)(itemNode, menuNode, {
          onlyScrollIfNeeded: true
        });
      }
    }
  }, {
    key: "findValue",
    value: function findValue(obj, list) {
      var i;

      for (i = 0; i < list.length; i++) {
        if (list[i] === obj.id) {
          return true;
        }
      }

      return false;
    }
  }, {
    key: "renderItem",
    value: function renderItem(item, isHighlighted, index) {
      var isChecked = this.findValue(item, this.props.value);
      return _react.default.createElement(_CwDropdownMultiItem.default, {
        cwId: this.props.cwId,
        isHighlighted: isHighlighted,
        isChecked: isChecked,
        item: item,
        onClick: this.handleItemClick,
        onMouseEnter: this.handleItemMouseEnter,
        onMouseDown: this.handleItemMouseDown,
        onMouseMove: this.handleItemMouseMove,
        index: index,
        key: index,
        ref: "item-".concat(index)
      });
    }
  }, {
    key: "renderToggle",
    value: function renderToggle(text, isHighlighted, index, isChecked) {
      return _react.default.createElement(_CwDropdownMultiItem.default, {
        cwId: this.props.cwId,
        isHighlighted: isHighlighted,
        isChecked: isChecked,
        item: {
          id: index,
          name: text
        },
        onClick: this.handleItemClick,
        onMouseEnter: this.handleItemMouseEnter,
        onMouseDown: this.handleItemMouseDown,
        onMouseMove: this.handleItemMouseMove,
        index: index,
        key: index,
        ref: "item-".concat(index)
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      if (this.props.items.length === 0) {
        return _react.default.createElement("div", {
          "data-cwid": this.props.cwId,
          className: _CwDropdownMulti.default.dropDown,
          style: this.props.style
        });
      } else {
        var selectAll = this.renderToggle(this.props.selectAllText, this.props.highlightedIndex === -1, -1, this.props.allSelected);
        var items = this.props.items.map(function (item, index) {
          return _this2.renderItem(item, _this2.props.highlightedIndex === index, index);
        });
        return _react.default.createElement("div", {
          "data-cwid": this.props.cwId,
          className: _CwDropdownMulti.default.dropDown,
          style: this.props.style,
          ref: "menu",
          onMouseEnter: this.handleDropdownEnter,
          onMouseLeave: this.handleDropdownLeave
        }, selectAll, items);
      }
    }
  }]);
  return CwDropdownMulti;
}(_react.default.Component);

CwDropdownMulti.propTypes = {
  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: _propTypes.default.string,

  /**
   * Array of items to be listed in the dropdown.
   */
  items: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
    name: _propTypes.default.string
  })),

  /**
   * Index of the currently highlighted item in the dropdown.
   */
  highlightedIndex: _propTypes.default.number,

  /**
   * Set of style properties to determine the dropdown's size and position. Must contain left, top, and minWidth.
   */
  style: _propTypes.default.shape({
    left: _propTypes.default.number,
    top: _propTypes.default.number,
    minWidth: _propTypes.default.number
  }),

  /**
   * Callback function that is fired when dropdown is clicked.
   */
  onClick: _propTypes.default.func,

  /**
   * Callback function that is fired when dropdown is hovered over.
   */
  onMouseEnter: _propTypes.default.func,

  /**
   * Callback function that is fired before onClick. Typically used to ignore blur in order to prevent dropdown from derezzing before a selection is registered.
   */
  onMouseDown: _propTypes.default.func,

  /**
   * Text to display on combobox picker
   */
  pickerText: _propTypes.default.string,

  /**
   * Flag to show it all records have been selected
   */
  allSelected: _propTypes.default.bool,

  /**
   * Localized text for the Select All option
   */
  selectAllText: _propTypes.default.string.isRequired
};
var _default = CwDropdownMulti;
exports.default = _default;